import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import useSWR from 'swr';

import { PageStyle } from '../../../../assets/styles/custom.styles';
import getErrorMessage from '../../../../assets/utils/getErrorMessage';
import PaginationComponent from '../../../../components/partner/paginationComponent';
import RemovedUserList from '../../../../components/partner/settings/reactivation/removedUsers';

const START_OF_PAGE = 1;

export interface RemovedUserObject {
  id: string;
  fullName: string;
  email: string;
  company: string;
  role: string;
  status: string;
}

interface RemovedUserObjectFromAPI {
  id: string;
  full_name: string;
  email: string;
  tenant_user_role: string;
  status: string;
  tenant: string;
}

const TransformDataFromApi = (data: RemovedUserObjectFromAPI[]):RemovedUserObject[]  => {
  if (!Array.isArray(data)) return [];
  const list: RemovedUserObject[] = data.map(({
    id, 
    full_name, 
    email, 
    tenant_user_role, 
    status, 
    tenant }) => ({
    id, 
    email, 
    status,
    fullName: full_name,
    company: tenant,
    role: tenant_user_role,
  }));

  return list;

};


const ReactivationPage = () => {

  const [listOfUsers, setListOfUsers] = useState<RemovedUserObject[]>([]);

  const [currPage, setCurrPage] = useState<number>(START_OF_PAGE);
  const [searchValue, setSearchValue] = useState<string>('');
  const [companyId, setCompanyId] = useState<string>('');
  const [paginationData, setPaginationData] = useState({
    total: 0,
    itemsPerPage: 0,
  });
  const [errorText, setErrorText] = useState<string>('');

  const { data, isLoading, error, mutate } = useSWR(`confide/removed-users?page=${currPage}&tenant=${companyId}&search=${searchValue}`, { revalidateOnFocus: true });

  useEffect(()=>{
    if (error)
      setErrorText(getErrorMessage(error));
    else {
      setListOfUsers(TransformDataFromApi(data?.results));
      setPaginationData({
        total: data?.count ?? 0,
        itemsPerPage: 25,
      });
    }
  }, [data, error]);
  
  const setSearchValuehandler = (value: string) => {
    setSearchValue(value);
    setCurrPage(START_OF_PAGE);
  };

  const setCompanyIdhandler = (value: string) => {
    setCompanyId(value);
    setCurrPage(START_OF_PAGE);
  };

  return (
    <Stack sx={PageStyle.container}>
      <RemovedUserList
        isLoading={isLoading}
        isError={error}
        errorText={errorText}
        list={listOfUsers}
        searchValue={searchValue}
        companyId={companyId}
        setSearchValue={setSearchValuehandler}
        setCompanyId={setCompanyIdhandler}
        mutate={mutate}
      />
      <PaginationComponent 
        ItemPerPage={paginationData.itemsPerPage}
        page={currPage}
        totalPages={Math.ceil(paginationData?.total / paginationData?.itemsPerPage)}
        totalCount={paginationData?.total}
        changePage={setCurrPage}
      />
    </Stack>
  );
};

export default ReactivationPage;